import React from 'react';
import './gmapCanvas.scss'
import iconImage from './icon.png';

/**
 * Google map
 */
class Gmap extends React.Component {
  componentDidMount() {
    this.renderCanvas()
  }
  
  componentDidUpdate() {
    if (this.updateOptFlg) {
      this.renderCanvas()
      this.updateOptFlg = false
    }
  }

  renderCanvas() {
    const { googleMaps } = this.props
    const mapCanvas = new googleMaps.Map(document.getElementById('map_canvas'), this.opts);
    this.addAllMarker(mapCanvas);
  }

  searchShop() {
    const { origin } = this.props
    // 検索後のデータで再表示
    this.createGmapOption(origin, 10);
  }

  selectShop() {
    const { shopList, selectedShop } = this.props
    if (!selectedShop.hasDetail) {
      return;
    }
    const shop = shopList.find(shop => shop.id === selectedShop.id)
    const lat = shop.latLng.lat()
    const lng = shop.latLng.lng()
    this.createGmapOption({ lat, lng }, 14)
  }

  createGmapOption(origin, zoom) {
    const { googleMaps } = this.props
    this.opts = {
      zoom: zoom,
      center: origin,
      mapTypeId: googleMaps.MapTypeId.ROADMAP
    }
    this.updateOptFlg = true
  }

  addAllMarker(mapCanvas) {
    const { shopList, googleMaps } = this.props
    shopList.forEach((shop, index) => {
      const marker = new googleMaps.Marker({
        map: mapCanvas,
        position: shop.latLng,
        icon: {
          url: iconImage ,
          scaledSize: new googleMaps.Size( 32, 41 ),
        },
      });

        // clickイベントを取得するListenerを追加
      new googleMaps.event.addListener(marker, 'click', () => this.handleOnClick(shop.id, shop.isOfficial));
    })
  }

  handleOnClick(shopId, isOfficial) {
    const { markerClickAction } = this.props
    const hasDetail = isOfficial
    markerClickAction(shopId, hasDetail)
  }

  render() {
    const { keywords, selectedShop } = this.props
    if (keywords) {
      // 検索された場合
      this.searchShop();
    }
    else if (selectedShop) {
      // ショップがクリックされた場合
      this.selectShop();
    }
    return (
      <div id="map_canvas" className="gmapCanvas" />
    );
  }
}

export default Gmap;
